import { AuthService } from '../services/AuthService';

const authService = new AuthService();
export class Roles {
  // getRoleLevel = permissions => {
  //   switch (permissions) {
  //     case 'viewer':
  //       return 0;
  //     case 'editor':
  //       return 1;
  //     case 'master':
  //       return 2;
  //     case 'owner':
  //       return 3;
  //     default:
  //       return;
  //   }
  // };

  roleLevel = permissions => {
    const role = authService
      .getFirebaseRoleLevel(permissions)
      .then(role => role);
    return role;
  };
}



// WEBPACK FOOTER //
// ./src/methods/Roles.js